import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const { user, ready } = useContext(AuthContext);

  if (!ready) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  return <Outlet />;
}
